import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import messageUtil from 'utils/messageUtil'

const Title = ({ viewOption }: { viewOption: InsightViewOptionStrings }) => {
  const { t } = useTranslation()

  return <div>{t('metricForSelectedItem', { metric: messageUtil.viewOption(viewOption) })}</div>
}

export default Title
